// Función para manejar el click del botón cambiar foto
export const handlePhotoButtonClick = (fileInputRef, subiendoFoto) => {
  if (fileInputRef && fileInputRef.current && !subiendoFoto) {
    fileInputRef.current.click();
  }
};
